import { Outlet, NavLink } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BASE_APP_PAth } from '../../api/launchpad-api';
import '../../pages/admin/admin.css';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0,
            retry: 1,
        },
    },
});

const ADMIN_BASE = `${BASE_APP_PAth}/admin`;

const navItems = [
    {
        section: 'Manage',
        links: [
            { path: '',                  label: 'Overview',           icon: 'icon-dashboard',     end: true  },
            { path: '/appetite-mapping', label: 'Appetite Mapping',   icon: 'icon-commercial',    end: false },
        ],
    },
    {
        section: 'Workflow',
        links: [
            { path: '/approval-queue',   label: 'Approval Queue',     icon: 'icon-policy-review', end: false },
            { path: '/bulk-operations',  label: 'Bulk Upload',        icon: 'icon-documents',     end: false },
        ],
    },
    {
        section: 'Monitoring',
        links: [
            { path: '/audit-logs',       label: 'Change History',     icon: 'icon-clock',         end: false },
        ],
    },
];

export const AdminLayout = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <div className="admin-layout">
                <aside className="admin-sidebar">
                    <div className="admin-sidebar-brand">
                        <span className="brand-badge">Commercial Launchpad Admin</span>
                        <h2>Carrier Recommendation Portal</h2>
                        <p>Appetite & Recommendation Management</p>
                    </div>
                    <nav>
                        <ul>
                            {navItems.map(section => (
                                <li key={section.section}>
                                    <div className="admin-nav-section">{section.section}</div>
                                    <ul>
                                        {section.links.map(item => (
                                            <li key={item.path}>
                                                <NavLink
                                                    to={`${ADMIN_BASE}${item.path}`}
                                                    end={item.end}
                                                    className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
                                                >
                                                    <span className={`admin-icon admin-nav-icon ${item.icon}`} aria-hidden="true" />
                                                    {item.label}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            ))}
                        </ul>
                    </nav>
                    <div className="admin-sidebar-footer">
                        GEICO Commercial Launchpad
                    </div>
                </aside>
                <main className="admin-content">
                    <Outlet />
                </main>
            </div>
        </QueryClientProvider>
    );
};
